<template>
    <div>
        <div class="col-xs-12 no-margin-bottom">

            <strong>
                <h4 class="text-center"> {{translateLocal('Entry Voucher') }}</h4>
            </strong>

            <Conditions
                v-bind:conditions="job.pricePolicy.pricePoliciesTranslations"
                v-on:toggleAcceptation=""
                v-bind:showAcceptation="false"
                v-bind:showConditions="showConditionsBlock"
                v-bind:accepted="voucher.conditions_entry_accepted"
                v-bind:jobWorkerIntervention="job.workerIntervention"
            >
            </Conditions>

            <HourEdit v-model="voucher.workTimeStart"
                v-on:toggleAcceptation="voucher.timeStartAccepted = !voucher.timeStartAccepted"
                v-bind:accepted="voucher.timeStartAccepted"
                v-bind:label="translateLocal('Confirm Hour')"
                v-bind:confirmHourVisible="true"
                v-bind:lang="job.workerIntervention.customer.lang"
            >
            </HourEdit>

            <p class="full-width accept_conditions_entry">
                <span> {{translateLocal('I claim to have read the ')}} </span><br>
                <a class="conditions-btn" @click="showConditionsBlock = !showConditionsBlock "> {{translateLocal('general conditions')}}</a>
                <span> {{translateLocal('and I accept them')}} </span>

                <input type="checkbox" id="accept_conditions_entry"  class="pull-right"
                       @click="voucher.conditions_entry_accepted = !voucher.conditions_entry_accepted"
                       v-bind:checked="voucher.conditions_entry_accepted"
                >
            </p>

            <div class="signature click-to-sign col-sx-12"
                 v-model="voucher.beforeEntrySignature"
                 v-on:click="voucher.beforeEntrySignature=true"
                 v-if="voucher.beforeEntrySignature === false &&
                 (voucher.conditions_entry_accepted ===true &&
                 voucher.timeStartAccepted === true)
                 "
            >
                <h4>{{translateLocal('Click to sign')}}</h4>
            </div>


            <div class="signature"
                 v-if="voucher.entry_signature==null &&
                    voucher.beforeEntrySignature===true &&
                    voucher.conditions_entry_accepted===true &&
                    voucher.timeStartAccepted === true">
                <VueSignaturePad
                        width="100%"
                        height="250px"
                        saveType="image/svg+xml"
                        ref="signatureEntry"
                        v-bind:options="{onEnd:detectSignatureEntry}"
                />
            </div>
            <div class="signature"  v-if="voucher.entry_signature!==null">
                <img v-bind:src="voucher.entry_signature" v-if="voucher.entry_signature!==null">
            </div>

        </div>

        <div class="col-xs-3 ">
            <button @click="undoEntry" class="btn btn-default">
                <i class="fa fa-undo"></i>
            </button>
        </div>

        <div class="col-xs-9 ">
            <button class="btn btn-primary"
                    v-bind:disabled="enabledButton"
                    v-model="voucher.isOkEntry"
                    v-on:click="saveEntry"
                    >
                OK
            </button>

        </div>
    </div>
</template>

<script>

    import Conditions from './Conditions';
    import HourEdit from './HourEdit';
    import translations from '../translations';

    export default {
        props: {
            voucher: null,
            job:null,
        },
        data() {
            return {
                showConditionsBlock: false,

            }
        },
        created(){

        },
        methods: {
            undoEntry() {
                this.voucher.entry_signature = null;
                this.voucher.is_entry_signature_empty = true;
                this.voucher.isOkEntry = false;
                if (this.$refs.signatureEntry) {
                    this.$refs.signatureEntry.clearSignature();
                }
            },
            saveEntry() {
                if (this.voucher.entry_signature === null) {
                    const {isEmpty, data} = this.$refs.signatureEntry.saveSignature();
                    this.voucher.entry_signature = data;
                }
                this.voucher.isOkEntry=true;
                this.$emit('save');
            },
            detectSignatureEntry() {
                let {isEmpty, data} = this.$refs.signatureEntry.saveSignature();
                let encoded = btoa(data);
                if(encoded.length > 800){
                    this.voucher.is_entry_signature_empty = false;
                }
            },
            clearSignature(){
                this.$refs.signature.clear();
            },
            translateLocal(key){
                let lang = this.job.workerIntervention.customer.lang === null ? 'en': this.job.workerIntervention.customer.lang ;
                if(translations[lang][key] !== undefined){
                    return translations[lang][key];
                }else{
                    return "___" + key;
                }
            }
        },
        computed:{
          enabledButton(){
              if((this.voucher.is_entry_signature_empty === false && this.voucher.conditions_entry_accepted && this.voucher.timeStartAccepted
              )){
                  return false;
              }
              return true;
          }
        },
        components: {
            Conditions,
            HourEdit
        },

    }
</script>

<style scoped>

    .accept_conditions_entry{
        text-align: left !important;
        font-size:13px;
        background-color:white;
        padding:10px;
        line-height: 19px;
    }

    .accept_conditions_entry input[type="checkbox"]{
        /* Double-sized Checkboxes */
        -ms-transform: scale(2); /* IE */
        -moz-transform: scale(2); /* FF */
        -webkit-transform: scale(2); /* Safari and Chrome */
        -o-transform: scale(2); /* Opera */
        /*padding: 10px;*/
        /*margin-top:-6px;*/
        margin:-6px 7px;
    }


    .accept_conditions_entry .conditions-btn{
        color: #007eec !important;
        text-decoration: underline;
    }

</style>


